<template>
  <div class="max-width">
    <v-row class="my-4">
      <ScanRecordFilter
        class="max-width"
        @search="search($event)"
        @clear="clear($event)"
      />
    </v-row>
    <v-row class="my-4">
      <ScanRecordList
        class="max-width"
        :scan-record-list="scanRecordList"
        @detail="detail"
      />
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="600px"
      >
        <ScanRecordUserDetails
          :row="row"
        />
      </v-dialog>
    </v-row>
  </div>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import ScanRecordFilter from './M0301ScanRecordFilter.vue'
import ScanRecordList from './M0301ScanRecordList.vue'
import ScanRecordUserDetails from './M0301ScanRecordUserDetails.vue'
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'

export default {
  name: 'ScanRecordSearch',
  components: {
    ScanRecordFilter,
    ScanRecordList,
    ScanRecordUserDetails
  },
  mixins: [ErrorDisplay],
  props: {
    scanRecordList: {
      type: Array,
      default: () => { return [] }
    }
  },
  data: function () {
    return {
      dialog: false,
      row: {}
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    search (event) {
      this.$emit('search', event)
    },
    detail (event) {
      this.dialog = true
      this.row = event
    },
    clear (event) {
      this.$emit('clear', event)
    }
  }
}
</script>

<style scoped>
.max-width {
  width: 100%
}
</style>
